import styled from 'styled-components';
import { tablet768, desktop1024, desktop1440 } from '@nubank/nuds-web/styles/breakpoints';

import Block from 'components/structure/Block/Block';
import { paddingBuilder } from 'styles/themeUtils';

const TextBlock = styled(Block)`
  ${paddingBuilder.all(3, 0, 3, 1.5)}

  ${tablet768`
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    flex: 1 1 50%;

    ${paddingBuilder.all(6, 0, 6, 3.5)}
  `}

  ${desktop1024`
    ${paddingBuilder.all(8.5, 0, 8.5, 3.5)}
  `}

  ${desktop1440`
    ${paddingBuilder.all(15.5, 0, 15.5, 3.5)}
  `}
`;

const InnerContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 650px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  ${paddingBuilder.right(1.5)}

  ${tablet768`
    ${paddingBuilder.right(3.5)}
  `}

  ${desktop1440`
    ${paddingBuilder.right(6.25)}
  `}
`;

InnerContainer.displayName = 'TextBlock.InnerContainer';

TextBlock.displayName = 'TextBlock';
TextBlock.InnerContainer = InnerContainer;

export default TextBlock;
